import React from 'react';

class TableColumn extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return <div className={`Table-column ${this.props.align}`}>{this.props.children}</div>;
  }
}

TableColumn.propTypes = {
  children: React.PropTypes.node,
  align: React.PropTypes.oneOf(['left', 'center', 'right'])
};

TableColumn.defaultProps = {
  children: null,
  align: 'center'
};

export default TableColumn;



// WEBPACK FOOTER //
// ./src/js/components/table/Column.js